import * as React from 'react'

import { useMobileResourceMeta } from '../context'

export const MobileResourceTitle: React.FC = () => {
  const { title, icon: IconComponent } = useMobileResourceMeta()

  return (
    <>
      <IconComponent className="tw:grow-0 tw:mr-2" size="lg" />
      <span className="tw:text-title-lg tw:font-semibold tw:text-foreground">
        {title}
      </span>
    </>
  )
}
